// BottomNav.jsx
import React, { useState, useRef, useEffect } from 'react';
import { FaSearch, FaClipboardList, FaBell, FaUser, FaHome, FaSignOutAlt, FaShieldAlt } from 'react-icons/fa';
import { useAuth } from '../context/AuthContext';

const LONG_PRESS_MS = 450;

export default function BottomNav({ active, onChange, unreadCount = 0 }) {
  const { user, logout } = useAuth();
  const [quickMenuOpen, setQuickMenuOpen] = useState(false);
  const longPressTimer = useRef(null);
  const longPressTriggered = useRef(false);
  const menuRef = useRef(null);

  const items = [
    { id: 'home', icon: FaHome, label: 'Inicio' },
    { id: 'search', icon: FaSearch, label: 'Buscar' },
    { id: 'historial', icon: FaClipboardList, label: 'Historial' },
    { id: 'notifications', icon: FaBell, label: 'Avisos', badge: unreadCount },
    { id: 'profile', icon: FaUser, label: 'Perfil' },
  ];

  // Cierra el menú rápido si tocas fuera de él
  useEffect(() => {
    if (!quickMenuOpen) return;
    const cerrar = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) setQuickMenuOpen(false);
    };
    document.addEventListener('mousedown', cerrar);
    document.addEventListener('touchstart', cerrar);
    return () => {
      document.removeEventListener('mousedown', cerrar);
      document.removeEventListener('touchstart', cerrar);
    };
  }, [quickMenuOpen]);

  const startLongPress = (id) => {
    if (id !== 'profile') return;
    longPressTimer.current = setTimeout(() => {
      longPressTriggered.current = true;
      setQuickMenuOpen(true);
    }, LONG_PRESS_MS);
  };

  const cancelLongPress = () => {
    if (longPressTimer.current) clearTimeout(longPressTimer.current);
  };

  const handleClick = (id) => {
    // Si acabamos de disparar el long-press, ignoramos el click normal
    // que llega justo después (al soltar el dedo/ratón), para no navegar
    // a la vez que se abre el menú rápido.
    if (longPressTriggered.current) {
      longPressTriggered.current = false;
      return;
    }
    onChange && onChange(id);
  };

  return (
    <nav style={{backgroundColor: '#0e1014', borderTop: '1px solid #1e2028'}}
      className="fixed bottom-0 left-0 right-0 z-50">

      {quickMenuOpen && (
        <div ref={menuRef} style={{
          position: 'absolute', bottom: '68px', right: '12px',
          backgroundColor: '#1a1d24', border: '1px solid #2a2d35',
          borderRadius: '16px', padding: '6px', minWidth: '190px',
          boxShadow: '0 12px 32px rgba(0,0,0,0.5)', zIndex: 60,
        }}>
          {user?.role === 'admin' && (
            <button
              onClick={() => { setQuickMenuOpen(false); onChange && onChange('profile'); }}
              style={{
                width: '100%', display: 'flex', alignItems: 'center', gap: '10px',
                padding: '10px 12px', borderRadius: '10px', background: 'none', border: 'none',
                color: '#9ca3af', fontSize: '13px', cursor: 'pointer', textAlign: 'left',
              }}>
              <FaShieldAlt style={{ fontSize: '13px', color: '#f97316' }} />
              Ir a mi perfil
            </button>
          )}
          <button
            onClick={() => { setQuickMenuOpen(false); logout(); }}
            style={{
              width: '100%', display: 'flex', alignItems: 'center', gap: '10px',
              padding: '10px 12px', borderRadius: '10px', background: 'none', border: 'none',
              color: '#f87171', fontSize: '13px', fontWeight: '600', cursor: 'pointer', textAlign: 'left',
            }}>
            <FaSignOutAlt style={{ fontSize: '13px' }} />
            Cerrar sesión
          </button>
        </div>
      )}

      <div className="flex justify-around items-center max-w-lg mx-auto px-2"
        style={{paddingTop: '10px', paddingBottom: '16px'}}>
        {items.map(({ id, icon: Icon, label, badge }) => {
          const isActive = active === id;
          return (
            <button key={id}
              onClick={() => handleClick(id)}
              onMouseDown={() => startLongPress(id)}
              onMouseUp={cancelLongPress}
              onMouseLeave={cancelLongPress}
              onTouchStart={() => startLongPress(id)}
              onTouchEnd={cancelLongPress}
              className="flex flex-col items-center gap-1 flex-1 transition duration-200">
              <div className="relative">
                <div style={{
                  padding: '7px',
                  borderRadius: '12px',
                  backgroundColor: isActive ? '#f9731615' : 'transparent',
                  transition: 'all 0.2s'
                }}>
                  <Icon style={{
                    fontSize: '18px',
                    color: isActive ? '#f97316' : '#4b5563',
                    transition: 'color 0.2s'
                  }} />
                </div>
                {badge > 0 && (
                  <span style={{
                    position: 'absolute', top: '2px', right: '2px',
                    backgroundColor: '#f97316', color: 'white',
                    fontSize: '9px', fontWeight: 'bold',
                    width: '14px', height: '14px',
                    borderRadius: '50%', display: 'flex',
                    alignItems: 'center', justifyContent: 'center'
                  }}>
                    {badge > 9 ? '9+' : badge}
                  </span>
                )}
              </div>
              <span style={{
                fontSize: '10px',
                color: isActive ? '#f97316' : '#4b5563',
                fontWeight: isActive ? '600' : '400',
                transition: 'color 0.2s'
              }}>
                {label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}